<script lang="ts">
    import { Col ,TabContent, TabPane} from "sveltestrap";
    import { BasicTabsContent, Contact, Home, Profile, TabsWithIcon } from "../../../../utils/Constant/Constant";
    import Card from "../../UiCommenCard.svelte";
</script>
<Col sm="12" xl="6"  class="xl-100">
    <Card cardHeaderprops="pb-0" headerTitle={TabsWithIcon}>
      <div slot="contentbody">
        <TabContent>    
            <TabPane tabId="Home" active>
                <span slot="tab">
                    <i class="icofont icofont-ui-home"></i> {Home} 
                </span>
                <p class="mb-0 m-t-30">{BasicTabsContent}</p>
            </TabPane>
            <TabPane tabId="Profile">
                <span slot="tab">
                    <i class="icofont icofont-man-in-glasses"></i> {Profile} 
                </span>
                <p class="mb-0 m-t-30">{BasicTabsContent}</p>
            </TabPane>
            <TabPane tabId="Contact">
                <span slot="tab">
                    <i class="icofont icofont-contacts"></i> {Contact} 
                </span>
                <p class="mb-0 m-t-30">{BasicTabsContent}</p>
            </TabPane>
          </TabContent>
      </div>
    </Card>
</Col>
